<template>
    <div>
        <section class="hero is-primary">
            <div class="hero-body">
                <div class="container">
                    <h1 class="title">
                        What do you want to do today?
                    </h1>
                    <h2 class="subtitle">
                        Pick a quick item or choose actions in the above menu
                    </h2>
                </div>
            </div>
        </section>

        <section>
            <div class="tile is-ancestor">
                <div class="tile is-parent is-vertical">
                    <div class="tile">
                        <div class="tile is-parent">
                            <div class="tile is-child box">
                                <article class="media">
                                    <figure class="media-left">
                                        <p class="image is-128x128">
                                            <img src="../assets/new.png">
                                        </p>
                                    </figure>
                                    <div class="content">
                                      <p class="title">Create a new game</p>
                                      <p>Create a new game assisted by our wizard.<br>
                                        Use this when you want to reuse maps and packs of activities.
                                      </p>
                                    </div>
                                </article>
                              <div align="right">
                                <button class="button is-success" @click="createNewBrandGame">Create a new game
                                </button>
                              </div>
                            </div>
                        </div>
                        <div class="tile is-parent">
                            <div class="tile is-child box">
                              <article class="media">
                                <figure class="media-left">
                                  <p class="image is-128x128">
                                    <img src="../assets/package.png">
                                  </p>
                                </figure>
                                <div class="content">
                                  <p class="title">Create a pack</p>
                                  <p>Create a new pack to be reused in games.<br>
                                    Use packs to cherry pick existing activities.
                                  </p>
                                </div>
                              </article>
                              <div align="right">
                                <button class="button is-success" @click="createPack">Create a new pack
                                </button>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="tile">
                        <div class="tile is-parent">
                            <div class="tile is-child box">
                              <article class="media">
                                <figure class="media-left">
                                  <p class="image is-128x128">
                                    <img src="../assets/map.png">
                                  </p>
                                </figure>
                                <div class="content">
                                  <p class="title">Create a new map</p>
                                  <p>Import a new Google Map<br>
                                    Import a new map to be the basis of new games.
                                  </p>
                                </div>
                              </article>
                                <div align="right">
                                  <button class="button is-success" @click="createMap">Import a map</button>
                                </div>
                            </div>
                        </div>
                        <div class="tile is-parent">
                            <div class="tile is-child box">
                              <article class="media">
                                <figure class="media-left">
                                  <p class="image is-128x128">
                                    <img src="../assets/activity.png">
                                  </p>
                                </figure>
                                <div class="content">
                                  <p class="title">Create a new activity</p>
                                  <p>Create or impart new challenges<br>
                                    Use the different challenge types for more fun!
                                  </p>
                                </div>
                              </article>
                              <div align="right">
                                <button class="button is-success" @click="createNewActivity">Create an activity
                                </button>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

  export default {
    name: 'main-screen',
    methods: {
      createNewBrandGame() {
        this.$router.push({name: 'CreateGameInSteps'})
      },
      createPack() {
        this.$router.push({name: 'CreatePack'})
      },
      createMap() {
        this.$router.push({name: 'MapImport'})
      },
      createNewActivity() {
        this.$router.push({name: 'CreateRawActivity'})
      }
    }
  }
</script>
